import * as React from 'react';
import { useEffect } from 'react';
import { HeaderElements } from "../HeaderElements/HeaderElements";
import LoaderAnimation from "../Loader/LoaderAnimation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlayCircle } from "@fortawesome/pro-regular-svg-icons/faPlayCircle";
import H1Header from "../WebmasterKit/H1Header";
import H1Text from "../WebmasterKit/H1Text";
import H2Header from "../WebmasterKit/H2Header";
import H2Text from "../WebmasterKit/H2Text";
import SeoFooter from "../WebmasterKit/SeoFooter";
import PhoneSexAdvertisements from "../Phonesex/PhoneSexAdvertisements";
import VXPaymentHint from "../Components/VXPaymentHint";
var Kaufvideos = function () {
  var _a = React.useState([]),
    videoData = _a[0],
    setVideoData = _a[1];
  var _b = React.useState(true),
    loading = _b[0],
    setLoading = _b[1];
  var _c = React.useState(0),
    page = _c[0],
    setPage = _c[1];
  useEffect(function () {
    fetch('/rest/videos').then(function (response) {
      return response.json();
    }).then(function (data) {
      return setVideoData(data.data);
    }).then(function () {
      return setLoading(false);
    });
  }, []);
  var kaufData = window.layoutSettings.seo.extraSubPages.video;
  var kaufMeta = kaufData.meta;
  var sliced = videoData.slice(page * 20, page * 20 + 20);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderElements, {
    canIndex: window.index.video,
    title: kaufMeta.title,
    description: kaufMeta.description
  }), /*#__PURE__*/React.createElement("div", {
    className: 'prodwidth center l-container h-center',
    id: "videos"
  }, /*#__PURE__*/React.createElement(H1Header, {
    text: kaufData.h1.title
  }), /*#__PURE__*/React.createElement(H1Text, {
    text: kaufData.h1.text
  }), /*#__PURE__*/React.createElement(H2Header, {
    text: kaufData.h2.title
  }), /*#__PURE__*/React.createElement(H2Text, {
    text: kaufData.h2.text
  }), /*#__PURE__*/React.createElement(VXPaymentHint, null), loading && /*#__PURE__*/React.createElement(LoaderAnimation, null), /*#__PURE__*/React.createElement("div", {
    className: "video__grid"
  }, sliced.map(function (video) {
    var minutes = Math.floor(video.duration / 60).toString().padStart(2, '0');
    var seconds = (video.duration % 60).toString().padStart(2, '0');
    return /*#__PURE__*/React.createElement("div", {
      className: "video__item",
      key: video.id
    }, /*#__PURE__*/React.createElement("a", {
      href: video.linkVX + '?' + window.ladd,
      target: "_blank"
    }, /*#__PURE__*/React.createElement("div", {
      className: "video_top"
    }, /*#__PURE__*/React.createElement("img", {
      src: video.preview.url,
      alt: ""
    }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      color: "white",
      size: "3x",
      icon: faPlayCircle
    })), /*#__PURE__*/React.createElement("div", {
      className: "video__bottom"
    }, /*#__PURE__*/React.createElement("div", {
      className: "video__model"
    }, video.model.name), /*#__PURE__*/React.createElement("div", {
      className: "video__duration"
    }, minutes, ":", seconds, " min"), /*#__PURE__*/React.createElement("div", {
      className: "video__title"
    }, video.title))));
  })), /*#__PURE__*/React.createElement("div", {
    className: "pagination prodwidth center gridreplace text-center push-bottom c-pagination l-container h-center"
  }, [1, 2, 3, 4, 5].map(function (i) {
    if (i - 1 === page) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "current c-pagination__item--current"
      }, i), " ");
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
        className: "c-pagination__item",
        onClick: function (e) {
          e.preventDefault();
          setPage(i - 1);
        },
        href: "#"
      }, i), " ");
    }
  })), /*#__PURE__*/React.createElement(PhoneSexAdvertisements, null), /*#__PURE__*/React.createElement(SeoFooter, {
    text: kaufData.footer.text
  })));
};
export default Kaufvideos;